module.exports = __webpack_public_path__ + "img/logo-pc.90c0a120.svg";